// Utils
import createAction from 'fc-utils/createAction'

export const START_PROCESS = '@@fc-ctrl/START_PROCESS'
export const FINISH_PROCESS = '@@fc-ctrl/FINISH_PROCESS'

export const PERMIT_CREATE = '@@fc-ctrl/PERMIT_CREATE'
export const PERMIT_READ = '@@fc-ctrl/PERMIT_READ'
export const PERMIT_UPDATE = '@@fc-ctrl/PERMIT_UPDATE'
export const PERMIT_DELETE = '@@fc-ctrl/PERMIT_DELETE'

export const DISPATCH_CREATE_INFORM = '@@fc-ctrl/DISPATCH_CREATE_INFORM'
export const DISPATCH_CREATE_SUCCESS = '@@fc-ctrl/DISPATCH_CREATE_SUCCESS'
export const DISPATCH_CREATE_FAIL = '@@fc-ctrl/DISPATCH_CREATE_FAIL'

export const DISPATCH_READ_INFORM = '@@fc-ctrl/DISPATCH_READ_INFORM'
export const DISPATCH_READ_SUCCESS = '@@fc-ctrl/DISPATCH_READ_SUCCESS'
export const DISPATCH_READ_FAIL = '@@fc-ctrl/DISPATCH_READ_FAIL'

export const DISPATCH_UPDATE_INFORM = '@@fc-ctrl/DISPATCH_UPDATE_INFORM'
export const DISPATCH_UPDATE_SUCCESS = '@@fc-ctrl/DISPATCH_UPDATE_SUCCESS'
export const DISPATCH_UPDATE_FAIL = '@@fc-ctrl/DISPATCH_UPDATE_FAIL'

export const DISPATCH_DELETE_INFORM = '@@fc-ctrl/DISPATCH_DELETE_INFORM'
export const DISPATCH_DELETE_SUCCESS = '@@fc-ctrl/DISPATCH_DELETE_SUCCESS'
export const DISPATCH_DELETE_FAIL = '@@fc-ctrl/DISPATCH_DELETE_FAIL'

export const INITIALIZE = '@@fc-ctrl/INITIALIZE'

// Local
function getWatchConfig (maybeWatch, operation) {
  if (typeof maybeWatch === 'boolean') {
    return !!maybeWatch
  } else if (typeof maybeWatch === 'string') {
    return maybeWatch.toUpperCase()
  } else if (typeof maybeWatch === 'object') {
    const maybeValue = maybeWatch[operation]

    if (typeof maybeValue === 'boolean') {
      return !!maybeValue
    } else if (typeof maybeValue === 'string') {
      return maybeValue.toUpperCase()
    }
  }

  return true
}
export function initialize ({
  url = null,
  model = null,
  tree = null,
  branch = null,
  watch: maybeWatch,
}) {
  return {
    type: INITIALIZE,
    payload: {
      url,
      model,
      tree,
      branch,
      watch: {
        create: getWatchConfig(maybeWatch),
        read: getWatchConfig(maybeWatch),
        update: getWatchConfig(maybeWatch),
        delete: getWatchConfig(maybeWatch),
      },
    },
  }
}
export const permitCreate = createAction(PERMIT_CREATE)
export const permitRead = createAction(PERMIT_READ)
export const permitUpdate = createAction(PERMIT_UPDATE)
export const permitDelete = createAction(PERMIT_DELETE)

export const createInform = createAction(DISPATCH_CREATE_INFORM)
export const createSuccess = createAction(DISPATCH_CREATE_SUCCESS)
export const createFail = createAction(DISPATCH_CREATE_FAIL)

export const readInform = createAction(DISPATCH_READ_INFORM)
export const readSuccess = createAction(DISPATCH_READ_SUCCESS)
export const readFail = createAction(DISPATCH_READ_FAIL)

export const updateInform = createAction(DISPATCH_UPDATE_INFORM)
export const updateSuccess = createAction(DISPATCH_UPDATE_SUCCESS)
export const updateFail = createAction(DISPATCH_UPDATE_FAIL)

export const deleteInform = createAction(DISPATCH_DELETE_INFORM)
export const deleteSuccess = createAction(DISPATCH_DELETE_SUCCESS)
export const deleteFail = createAction(DISPATCH_DELETE_FAIL)
